import { posthogEvents } from '@/shared/constants/constants';
import { posthogLog } from '@/shared/pinia/modules/posthog/logger';

export const trackDomainMismatchNudgeShown = (data: {
  current_domain: string;
  detected_country: string;
  suggested_domain: string;
}): void => {
  posthogLog('domain_mismatch_nudge_shown', data);
  window.posthog?.capture(posthogEvents.DOMAIN_MISMATCH_NUDGE_SHOWN, data);
};

export const trackDomainMismatchNudgeAccepted = (data: {
  from_domain: string;
  to_domain: string;
  target_url: string;
  fallback_to_homepage: boolean;
}): void => {
  posthogLog('domain_mismatch_nudge_accepted', data);
  window.posthog?.capture(posthogEvents.DOMAIN_MISMATCH_NUDGE_ACCEPTED, data);
};

export const trackDomainMismatchNudgeDismissed = (data: {
  current_domain: string;
  suggested_domain: string;
}): void => {
  posthogLog('domain_mismatch_nudge_dismissed', data);
  window.posthog?.capture(posthogEvents.DOMAIN_MISMATCH_NUDGE_DISMISSED, data);
};

export const trackDomainMismatchDetectionFailed = (data: {
  current_domain: string;
  failure_reason: string;
}): void => {
  posthogLog('domain_mismatch_detection_failed', data);
  window.posthog?.capture(posthogEvents.DOMAIN_MISMATCH_DETECTION_FAILED, data);
};
